<template>
  <div class="main-page">
    <Menus title="人民调解" />
    <div class="container-flex">
      <div class="content">
        <div class="title">
          申请须知
        </div>
        <div class="desc">
          <p>1、平台面向云南省居民提供在线人民调解申请;。</p>
          <p>2、申请内容填报包括当事人真实信息、纠纷客观描述、证据资料等，资料填写必须真实可靠;</p>
          <p>3、调委会选择时，原则上只能选择纠纷一方当事人户籍所在地或纠纷发生所在辖区调委会，选择其他地区调委会，可能导致申请不成功;</p>
          <p>4、调解申请原则上不接受选择所在地(发生地)之外的其它调委会;</p>
          <p>5、一般性纠纷原则上只能选择所在地乡(镇)级调委会;</p>
          <p>6、专业性(行业性)纠纷原则上只能选择区(县)调委会，所在地实际调委会;</p>
          <p>7、平台目前只受理乡镇级及以上人民调解委员会调解申请;</p>
          <p>8、平台暂不受理省级人民调解组织调解申请;</p>
          <p>9、法律法规规定不在调解之列的不予受理。</p>
          <div class="tipinfo">
            提示：请务必阅读须知，了解调解申请规则。
          </div>
        </div>
        <router-link
          to="/mediation/applyInfo?url=/mediation/apply"
          class="button"
        >
          知道了
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { MEDIATION_APPLY } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menus
  },
  mounted () {
    this.$root.getStatistics(MEDIATION_APPLY)
  }
}
</script>
<style lang="stylus" scoped>
.content
  width 12.7rem
  display block
  margin 0 auto 0.3rem auto
  padding 0.5rem 0.7rem 0.6rem 0.7rem
  background-color rgba(255, 255, 255, 0.2)
  border-radius 0.3rem
  border solid 1px rgba(255, 255, 255, 0.2)
  color #fff
  .title
    font-size 0.3rem
    line-height 0.3rem
    padding-bottom 0.56rem
    letter-spacing 1px
  .info-title
    font-size 0.28rem
    padding 0.15rem 0
  .desc
    font-size 0.24rem
    line-height 2
  .tipinfo
    letter-spacing 0
    color #ec3839
  .button
    display block
    margin 0.6rem auto 0 auto
    width 2.78rem
    text-align center
    height 0.9rem
    line-height 0.9rem
    border 0
    color #fff
    background-color #fc9d0b
    border-radius 0.1rem
    font-size 0.28rem
</style>
